import { IIepePortSettingsTemplateResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { constructSearchExpression, toDataSourceResult } from 'utils/query_v3';

export type TemplatesFilter = Readonly<{
    locationId: string;
    nameSearch?: string;
}>;

export type TemplatesDataSourceOptions = BaseDataSourceOptions<
    IIepePortSettingsTemplateResponse,
    TemplatesFilter
>;
export type TemplatesPagedDataSource = PagedDataSource<
    IIepePortSettingsTemplateResponse,
    TemplatesFilter
>;
export type TemplatesInfiniteDataSource = InfiniteDataSource<
    IIepePortSettingsTemplateResponse,
    TemplatesFilter
>;

const getAllTemplates: DataSourceQuery<
    IIepePortSettingsTemplateResponse,
    TemplatesFilter
> = ({ filter: { locationId, nameSearch }, page, pageLimit }) => {
    const searchExpr = constructSearchExpression(nameSearch ?? '', ['Name']);

    return toDataSourceResult(
        sdClient.getNodeSettingsTemplates({
            locationId,
            filter: searchExpr,
            page,
            pageLimit,
        }),
    );
};

export function usePagedTemplatesDataSource({
    ...options
}: TemplatesDataSourceOptions): TemplatesPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: getAllTemplates,
    });
}

export function useInfiniteTemplatesDataSource({
    ...options
}: TemplatesDataSourceOptions): TemplatesInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: getAllTemplates,
    });
}
